import React, { Component } from 'react';
import { translate } from 'react-i18next';
import SvgIcon from 'react-icons-kit';
import { archive } from 'react-icons-kit/ionicons/archive';
import { Button } from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';
import HLAForm from './Components/hlaForm';
import swal from 'sweetalert';
import $ from 'jquery';

var Config = require('../../../config');

class HLAResults extends Component {
    constructor(props){
        super(props);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getAllels = this.getAllels.bind(this);
        this.changeAllels = this.changeAllels.bind(this);
        this.openFile = this.openFile.bind(this);
        this.loadFile = this.loadFile.bind(this);

        this.state = {
            petition_id: 0,
            pdf:[],
            patient: "",
            clinic_history: "",
            allels_results: [],
            samples:[],
            sample_id:"",
            edit:false
        };
    }

    componentDidMount(){
        var id = this.props.match.params.id;

        fetch(Config.default.apiGateway.URL+'petitions/get_samples?petition_id='+id,{
            method:'get',
            headers: new Headers({
                'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                'Accept'		: 'application/json',
                'Content-Type'	: 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }
        }).then(response => {
            if(response !== undefined){
                var samples = [];
                response.map((res)=>
                    samples.push({
                        id: res.sample.id,
                        number: res.sample.number
                    })
                );

                this.setState({samples: samples});
            }
        });
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});

        var id = this.props.match.params.id;
        this.getAllels(id, e.target.value);
    }

    getAllels(id, sample){
        fetch(Config.default.apiGateway.URL+'allels_results?petition_id='+id+
            '&samples_id='+sample,{
            method:'get',
            headers: new Headers({
                'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                'Accept'		: 'application/json',
                'Content-Type'	: 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }
        }).then(response => {
            if(response !== undefined){
                this.setState({patient:response.patient});
                this.setState({clinic_history:response.clinic_history});

                var alleles = [];

                response.petition_type_alleles.map(i => {
                    var obj = {
                        id: i.id,
                        allelo: i.allelo,
                        results:{
                            allelo:i.allelo,
                            father:"",
                            father_complete:"",
                            mother:"",
                            mother_complete:""
                        }
                    }
                    var index =  response.allels_results.findIndex(r => r.allelo == i.allelo);
                    
                    if(index !== -1){
                        obj.results = response.allels_results.find(r => r.allelo == i.allelo);
                        this.setState({edit:true});
                    }

                    return alleles.push(obj);
                });

                this.setState({allels_results: alleles});
            }
        });
    }

    changeAllels(name, value, i){
        var allels = this.state.allels_results;

        allels[i].results[name] = value;

        this.setState({allels_results: allels});
    }

    onCancel(){
		this.props.history.push('/petition_register');
	}

    onSave() {
        var id = this.props.match.params.id;
        var obj = [];
        this.state.allels_results.map((allel)=>
            obj.push(allel.results)
        );

        this.props.waiting.handleShow('Guardando...');
        fetch(Config.default.apiGateway.URL+'allels_results?petition_id='+id+
            '&samples_id='+this.state.sample_id,{
            method: this.state.edit ? 'PUT' : 'POST',
            body:JSON.stringify(obj),
            headers: new Headers({
                'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                'Accept'		: 'application/json',
                'Content-Type'	: 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            
            if(res.ok){
                return res.json();
            }
        }).then(response => {
            if(response !== undefined){
                this.getAllels(id, this.state.sample_id);
            }
        });
    }



    openFile(){
        $('#contained-button-file').click();
    }

    readFileDataAsBase64(e) {
        const file = e.target.files[0];
    
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
    
            reader.onload = (event) => {
                resolve(event.target.result);
            };
    
            reader.onerror = (err) => {
                reject(err);
            };
    
            reader.readAsDataURL(file);
        });
    }

    async loadFile(e){
        var file = await this.readFileDataAsBase64(e);

        var id = this.props.match.params.id;
        var obj = {
            petition_id: id,
            samples_id: this.state.sample_id,
            pdf: file
        }       

        this.props.waiting.handleShow('Cargando...');
        fetch(Config.default.apiGateway.URL+'allels_results/read_pdf',{
            method: 'POST',
            body:JSON.stringify(obj),
            headers: new Headers({
                'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                'Accept'		: 'application/json',
                'Content-Type'	: 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            
            if(res.ok){
                return res.json();
            }else{
                res.text().then(msg =>
                    swal('Error', msg, 'error')    
                );
            }
        }).then(response => {
            if(response !== undefined){
                this.getAllels(id, this.state.sample_id);
            }
        });
    }

    render() {
        const {t} = this.props;

        return(
            <div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
          				{'Resultados HLA'}
					</h5>
				</div>
                <form noValidate>
                    <div className="col-xs-12">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span className="span-min">Número de Expediente: </span>
						</div>
						<div className="col-xs-12 col-sm-9">
							<span className="color-font">{this.state.clinic_history}</span>
						</div>
					</div>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span className="span-min">Nombre de Paciente: </span>
						</div>
						<div className="col-xs-12 col-sm-6">
							<span className="color-font">{this.state.patient}</span>
                        </div>
					</div>
                    <div className="col-xs-12">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span className="span-min">Muestra: </span>
						</div>
						<div className="col-xs-12 col-sm-2">
                            <select className="form-control" id="sample_id" name="sample_id"
                                value={this.state.sample_id} onChange={(e)=>this.handleChange(e)} >
                                <option value="">Seleccione...</option>
                                {this.state.samples.map((sample, i)=>
                                    <option value={sample.id} key={i}>
                                        {sample.number}
                                    </option>
                                )}
                            </select>
                        </div>
					</div>

                    <div className="col-sm-8">
                        <fieldset>
                            <legend>Resultados HLA</legend>
                            <div className="row border" style={{margin: "0", paddingTop: "0.5em"}}>
                                {this.state.allels_results.map((allel, i) => (
                                    <HLAForm 
                                        {...this.props}  
                                        key={i} 
                                        state={allel} 
                                        index={i}
                                        changeAllels={this.changeAllels}
                                    />
                                ))}
                            </div>
                        </fieldset>
                    </div>
                    <div className="col-sm-4">
                        <fieldset>
                            <legend>Cargar archivo</legend>
                            <div>
                                <input
                                    type="file"
                                    accept="application/pdf"
                                    style={{ display: 'none' }}
                                    name="pdf"
                                    id="contained-button-file"                                    
                                    onChange={(e)=>this.loadFile(e)}
                                    ref={(ref) => this.fileUpload = ref}
                                />
                                
                                <Button className="btn btn-info" variant="contained" color="primary" component="span"
                                    style={{fontSize:"1em", marginTop:"12px", width:'100%'}}
                                    onClick={this.openFile}
                                    disabled={this.state.sample_id === ""}
                                >
                                    <SvgIcon icon={archive} style={{marginRight:"0.5em"}}/>
                                    Subir archivo
                                </Button>
                                
                            </div>
                        </fieldset>
                    </div>
                    
                    <div className="col-xs-12" style={{textAlign:'center'}}>
                        <RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
				        	onClick={this.onSave}  style={{margin:12}}
							disabled={this.state.save}/>
				        <RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onCancel}/>
                    </div>
                </form>
            </div>
        )
    }
}

export default translate('translations') (HLAResults);